export const language: any ={
  main: "메인",
  ingredients: "식재료",
  ai_chef: "AI 쉐프",
  favorites: "즐겨찾기",
  menu: "메뉴",
  get_start: "시작하기",
  title_first_1: "연령별 래시피 추천 AI",
  title_second_1: "식단부터 요리 레시피 완벽 정리!",
  content_1: "매일 고민이던 하루 식단과 칼로리, 이제 고민하지말고 헤이!쿠커의 추천을 받아보세요.",
  title_first_2: "오늘도 추운데 고생하셨네요",
  title_second_2: "퇴근하고 부대찌개 어때요?",
  content_2: "냉장고에 남아있는 스팸과 라면사리를 찾아간편하게 저녁요리를 만들어보아요!",
  my_food_ingredients: "무슨 요리할지 모르겠어요?",
  btn_add_photo: "이미지를 선택하거나<br/>사진을 찍으세요.",
  my_food_reason: "가진 식재료를 선택하세요",
  btn_get_cooking: "AI 요리 추천받기",
  enriching_title: "레시피 큐레이션",
  enriching: "몸과 마음이 풍성해지는",
  photo_registration_title: " AI 쉐프가 당신을 위해<br/>요리를 추천할 준비가 되어 있어요",
  photo_registration_content: `AI로 재료를 식별하고 레시피를 분석하여<br/>요리의 즐거움을 더해보세요!`,
  food_suggestions_title: "무엇을 먹을지 고민이라면?",
  food_suggestions_sub_title: "테마별 요리",
  our_interests_title: "본인과 가족에게 딱 맞는 메뉴를 만들어봅시다!",
  our_interests_sub_title: "연령, 성별에 따라 선택하세요.",
  favorite_title: "요리조리 요리 노트",
  weather_title: "쌀쌀한 날씨에 어울리는 음식  🔥",
  video_title: "🍕  생생한 동영상으로 확인하는",
  tag: {
    close: "닫기",
    open: "펼치기"
  },
  no_data: "데이터가 없습니다",
  update_version_submit: "바로 업데이트",
  update_version_title: "최신 버전의 앱이 있습니다.",
  update_version_content: `최적의 사용 환경을 위해 <br />최신 버전의 앱으로 업데이트해주세요.`,
  close_btn: "닫기",
  not_video_id: "동영상이 존재하지 않습니다",
  favorite_login: "즐겨찾기 레시피 리스트를 저장하기 위해 로그인 또는 회원가입하세요.",
  view_recipe: "선택한 재료로 레시피 보기",
  my_ingredient: "나의 식재료로 가기",
  add_ingredient: "나의 식재료 추가",
  favorite_section_title: "저장한 레시피를 꼭 확인해보세요",
  favorite_section_description: "나의 즐겨찾는 레시피",
  discover:"메인",
  my_cooker:"내 주방",
  video_section_title: "영상으로 찾아보고 느껴보세요",
  video_section_description: "추천 요리 영상",
  age_10: "U10",
  age_10_to_20: "10-20세",
  age_20_to_30: "20-30세",
  age_30_to_40: "30-40세",
  age_40_to_50: "40-50세",
  age_more_50: "50+",
  weather_title1: "오늘의 추천",
  weather_title2: "비 오는 쌀쌀한 날에 어울리는 요리",
  tasteSuggestion1: "취향에 따라 추천 드릴께요",
  tasteSuggestion2: "당신의 미각을 만족시켜 보세요!",
  tasteTitle1: "매운 맛의매력",
  // tasteDescription1: "#볶음#구이<br /> <span> </span> #비 오는 날",
  tasteTitle2: "신선함, 담백함",
  // tasteDescription2: "#볶음#구이<br /> <span> </span> #비 오는 날",
  tasteTitle3: "자극적인 신맛",
  // tasteDescription3: "#볶음#구이<br /> <span> </span> #비 오는 날",
  tasteTitle4: "향긋하고 달콤함",
  // tasteDescription4: "#볶음#구이<br /> <span> </span> #비 오는 날",
  tasteTitle5: "조화롭고 매력적인",
  // tasteDescription5: "#볶음#구이<br /> <span> </span> #비 오는 날",
  tasteDescription1: "#볶음 #구이 #비오는 날",
  tasteDescription2: "#신선한 #섬유질 #다이어트",
  tasteDescription3: "#새콤달콤 #흥미진진",
  tasteDescription4: "#독특한 #씨앗 #마법",
  tasteDescription5: "#맛 #영양 #느낌",
  suggest_section_title: "Hey! Cooker 선택을 도와드리겠습니다",
  suggest_section_description: "관심있는 주제가 무엇일까요?",
  suggest_item_title1: "간단한 요리",
  suggest_item_description1: `간단한 아침과 점심<br/> 레시피`,
  suggest_item_title2: "다이어트",
  suggest_item_description2: `저탄수화물<br/>정말 맛있음`,
  suggest_item_title3: "연말 음식",
  suggest_item_description3: `집밥 파티 음식`,
  suggest_item_title4: "건강한 음식",
  suggest_item_description4: `건강한 몸과 정신을<br/> 만들기`,
  suggest_item_title5: "간단한 간식",
  suggest_item_description5: `혼술 안주`,
  history: '이미지 분석 이력',
  community: {
    sub_title: "모두와 함께 요리하기",
    title: "Hey! Cooker 커뮤니티 탐색하기",
    trending: "트렌드",
    follow: "팔로잉",
    video: "동영상",
    discover :"탐색",
    no_data: "Hey! Cooker 커뮤니티에서 새로운 업데이트가 없습니다",
    discover_post: "커뮤니티에서 더 많은 게시글 탐색하기",
  },
  user_suggest_title1: "오늘의 추천",
  user_suggest_title2: "랜덤 레시피 추천",
}

